import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import DateInput from '../components/ui/DateInput';

const COURSES = ['PGDCEM-M','PGDCEM-C','DCEM-C','MP+PGDCEM-M','CP+PGDCEM-C','PG-O&G','D-O&G','MP+PG-O&G','DMEP','MP+NDT','CP+DCEM','NDT','HSE','QA/QC','MEP','HVAC','MP'];
const CENTRES = ['EKM','TVM'];
const QUALIFICATIONS = ['BE-Mech','BE-Civil','Diploma-Mech','Diploma-Civil','BSc','BA','ITI','Plus Two','SSLC','Other'];
const KERALA_DISTRICTS = ['Thiruvananthapuram','Kollam','Pathanamthitta','Alappuzha','Kottayam','Idukki','Ernakulam','Thrissur','Palakkad','Malappuram','Kozhikode','Wayanad','Kannur','Kasaragod'];

export default function Apply() {
  const [form, setForm] = useState({
    full_name:'', date_of_birth:'', gender:'', contact_number:'', whatsapp_number:'',
    email:'', address:'', pincode:'', district:'', state:'Kerala', known_location:'',
    guardian_name:'', guardian_contact:'', college_name:'', academic_qualification:'',
    professional_qualification:'', course_name:'', centre:'', training_mode:'offline',
  });
  const [saving, setSaving] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const sf = (k,v) => setForm(f=>({...f,[k]:v}));

  function validate() {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Required';
    if (!form.contact_number.trim()) e.contact_number = 'Required';
    if (!form.course_name) e.course_name = 'Required';
    if (!form.centre) e.centre = 'Required';
    if (!form.academic_qualification) e.academic_qualification = 'Required';
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    setSaving(true);
    const { error } = await supabase.from('student_applications').insert({
      ...form,
      date_of_birth: form.date_of_birth || null,
      status: 'pending',
    });
    setSaving(false);
    if (error) { alert('Error submitting. Please try again.\n' + error.message); return; }
    setSubmitted(true);
  }

  if (submitted) return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#00756a 0%,#005f55 100%)',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{background:'#fff',borderRadius:20,padding:48,maxWidth:480,width:'100%',textAlign:'center',boxShadow:'0 20px 60px rgba(0,0,0,0.15)'}}>
        <div style={{fontSize:64,marginBottom:16}}>✅</div>
        <h2 style={{color:'#00756a',marginBottom:12,fontSize:24}}>Application Submitted!</h2>
        <p style={{color:'#64748b',marginBottom:8,lineHeight:1.6}}>Thank you for your interest in Armstech Engineers Pvt Ltd.</p>
        <p style={{color:'#64748b',lineHeight:1.6}}>Our team will review your application and contact you shortly on <strong>{form.contact_number}</strong>.</p>
        <div style={{marginTop:24,padding:'16px',background:'#f0fdf4',borderRadius:12,border:'1px solid #bbf7d0'}}>
          <p style={{color:'#16a34a',fontWeight:600,margin:0}}>📞 For queries: +91 XXXXXXXXXX</p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#00756a 0%,#005f55 100%)',padding:'24px 16px'}}>
      <div style={{maxWidth:720,margin:'0 auto'}}>
        {/* Header */}
        <div style={{textAlign:'center',marginBottom:32,color:'#fff'}}>
          <div style={{fontSize:48,marginBottom:8}}>🎓</div>
          <h1 style={{fontSize:28,fontWeight:800,margin:0}}>Armstech Engineers Pvt Ltd</h1>
          <p style={{opacity:0.85,marginTop:8,fontSize:16}}>Student Application Form</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Personal Details */}
          <div style={{background:'#fff',borderRadius:16,padding:24,marginBottom:20,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
            <h3 style={{color:'#00756a',marginBottom:20,fontSize:16,fontWeight:700,borderBottom:'2px solid #e2e8f0',paddingBottom:10}}>👤 Personal Details</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Full Name *</label>
                <input style={inp(errors.full_name)} value={form.full_name} onChange={e=>sf('full_name',e.target.value)} placeholder="Enter your full name"/>
                {errors.full_name && <span style={err}>{errors.full_name}</span>}
              </div>
              <div>
                <label style={lbl}>Date of Birth</label>
                <DateInput style={inp()} value={form.date_of_birth} onChange={e=>sf('date_of_birth',e.target.value)}/>
              </div>
              <div>
                <label style={lbl}>Gender</label>
                <select style={inp()} value={form.gender} onChange={e=>sf('gender',e.target.value)}>
                  <option value="">Select</option>
                  <option>Male</option><option>Female</option><option>Other</option>
                </select>
              </div>
              <div>
                <label style={lbl}>Contact Number *</label>
                <input style={inp(errors.contact_number)} value={form.contact_number} onChange={e=>sf('contact_number',e.target.value)} placeholder="10-digit mobile number"/>
                {errors.contact_number && <span style={err}>{errors.contact_number}</span>}
              </div>
              <div>
                <label style={lbl}>WhatsApp Number</label>
                <input style={inp()} value={form.whatsapp_number} onChange={e=>sf('whatsapp_number',e.target.value)} placeholder="If different from contact"/>
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Email</label>
                <input type="email" style={inp()} value={form.email} onChange={e=>sf('email',e.target.value)} placeholder="your@email.com"/>
              </div>
            </div>
          </div>

          {/* Address */}
          <div style={{background:'#fff',borderRadius:16,padding:24,marginBottom:20,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
            <h3 style={{color:'#00756a',marginBottom:20,fontSize:16,fontWeight:700,borderBottom:'2px solid #e2e8f0',paddingBottom:10}}>📍 Address Details</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Address</label>
                <textarea style={{...inp(),height:72,resize:'vertical'}} value={form.address} onChange={e=>sf('address',e.target.value)} placeholder="House No, Street, Area"/>
              </div>
              <div>
                <label style={lbl}>Known Location / Landmark</label>
                <input style={inp()} value={form.known_location} onChange={e=>sf('known_location',e.target.value)} placeholder="Near..."/>
              </div>
              <div>
                <label style={lbl}>Pincode</label>
                <input style={inp()} value={form.pincode} onChange={e=>sf('pincode',e.target.value)} placeholder="682001"/>
              </div>
              <div>
                <label style={lbl}>District</label>
                <select style={inp()} value={form.district} onChange={e=>sf('district',e.target.value)}>
                  <option value="">Select District</option>
                  {KERALA_DISTRICTS.map(d=><option key={d}>{d}</option>)}
                  <option value="Other">Other</option>
                </select>
              </div>
              <div>
                <label style={lbl}>State</label>
                <input style={inp()} value={form.state} onChange={e=>sf('state',e.target.value)} placeholder="Kerala"/>
              </div>
            </div>
          </div>

          {/* Guardian */}
          <div style={{background:'#fff',borderRadius:16,padding:24,marginBottom:20,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
            <h3 style={{color:'#00756a',marginBottom:20,fontSize:16,fontWeight:700,borderBottom:'2px solid #e2e8f0',paddingBottom:10}}>👨‍👩‍👦 Guardian Details</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div>
                <label style={lbl}>Guardian Name</label>
                <input style={inp()} value={form.guardian_name} onChange={e=>sf('guardian_name',e.target.value)} placeholder="Father/Mother/Guardian"/>
              </div>
              <div>
                <label style={lbl}>Guardian Contact</label>
                <input style={inp()} value={form.guardian_contact} onChange={e=>sf('guardian_contact',e.target.value)} placeholder="10-digit mobile"/>
              </div>
            </div>
          </div>

          {/* Academic */}
          <div style={{background:'#fff',borderRadius:16,padding:24,marginBottom:20,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
            <h3 style={{color:'#00756a',marginBottom:20,fontSize:16,fontWeight:700,borderBottom:'2px solid #e2e8f0',paddingBottom:10}}>🎓 Academic Details</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div>
                <label style={lbl}>Academic Qualification *</label>
                <select style={inp(errors.academic_qualification)} value={form.academic_qualification} onChange={e=>sf('academic_qualification',e.target.value)}>
                  <option value="">Select Qualification</option>
                  {QUALIFICATIONS.map(q=><option key={q}>{q}</option>)}
                </select>
                {errors.academic_qualification && <span style={err}>{errors.academic_qualification}</span>}
              </div>
              <div>
                <label style={lbl}>Professional Qualification (if any)</label>
                <input style={inp()} value={form.professional_qualification} onChange={e=>sf('professional_qualification',e.target.value)} placeholder="e.g. CSWIP, ASNT Level II"/>
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>College / Institution</label>
                <input style={inp()} value={form.college_name} onChange={e=>sf('college_name',e.target.value)} placeholder="College/University name"/>
              </div>
            </div>
          </div>

          {/* Course */}
          <div style={{background:'#fff',borderRadius:16,padding:24,marginBottom:24,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
            <h3 style={{color:'#00756a',marginBottom:20,fontSize:16,fontWeight:700,borderBottom:'2px solid #e2e8f0',paddingBottom:10}}>📚 Course Preference</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div>
                <label style={lbl}>Course *</label>
                <select style={inp(errors.course_name)} value={form.course_name} onChange={e=>sf('course_name',e.target.value)}>
                  <option value="">Select Course</option>
                  {COURSES.map(c=><option key={c}>{c}</option>)}
                </select>
                {errors.course_name && <span style={err}>{errors.course_name}</span>}
              </div>
              <div>
                <label style={lbl}>Preferred Centre *</label>
                <select style={inp(errors.centre)} value={form.centre} onChange={e=>sf('centre',e.target.value)}>
                  <option value="">Select Centre</option>
                  {CENTRES.map(c=><option key={c}>{c}</option>)}
                </select>
                {errors.centre && <span style={err}>{errors.centre}</span>}
              </div>
              <div>
                <label style={lbl}>Training Mode</label>
                <select style={inp()} value={form.training_mode} onChange={e=>sf('training_mode',e.target.value)}>
                  <option value="offline">Offline</option>
                  <option value="online">Online</option>
                </select>
              </div>
            </div>
          </div>

          <button type="submit" disabled={saving} style={{
            width:'100%',padding:'16px',borderRadius:12,border:'none',cursor:'pointer',
            background:saving?'#94a3b8':'#00756a',color:'#fff',fontSize:16,fontWeight:700,
            boxShadow:'0 4px 14px rgba(0,117,106,0.4)',transition:'all 0.2s',
          }}>
            {saving ? '⏳ Submitting...' : '📤 Submit Application'}
          </button>
          <p style={{textAlign:'center',color:'rgba(255,255,255,0.8)',marginTop:12,fontSize:13}}>
            By submitting, you agree to be contacted by Armstech regarding your application.
          </p>
        </form>
      </div>
    </div>
  );
}

const lbl = {display:'block',fontSize:12,fontWeight:600,color:'#374151',marginBottom:6};
const inp = (e) => ({
  width:'100%',padding:'10px 12px',borderRadius:8,fontSize:14,
  border:`1.5px solid ${e?'#ef4444':'#d1d5db'}`,outline:'none',
  background:'#f9fafb',boxSizing:'border-box',
});
const err = {fontSize:11,color:'#ef4444',marginTop:4,display:'block'};
